module.exports = __webpack_public_path__ + "img/ico-hack.248b04eb.svg";